import TomClient from "../../../anwendungskonfigurator/services/tomClient"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"
import defaultDataJson from "../../../generated/mbk/dataStructur.json"
import {removeNullValues} from "../../../anwendungskonfigurator/misc/utils"

const navigationPaths = Object.freeze({
    SUCHE: "/suche",
    JP_KUNDE_ANLEGEN: "/kunde/jp/:id",
    NP_KUNDE_ANLEGEN: "/kunde/np/:id",
})

const uwpApiBase = globalThis._env_.UWPPLUS_BACKEND_API_URL + "/api"

const links = Object.freeze({
    copy: "/_links/copy/href",
    vermittlerList: "/_links/vermittlerList/href",
    selectedNpKunde: "/natuerlicheperson",
    selectedJpKunde: "/juristischeperson",
})

const rawAddress = {
    art: null,
    gueltig: false,
    hauptadresse: false,
    hausnummer: null,
    land: null,
    modelId: null,
    ort: null,
    postfach: null,
    postleitzahl: null,
    strasse: null,
}

export const KundeActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    getDataFromBackend,
    sendDataToBackend,
    loadCurrentLocationData,
    getDataFromBackendWithQuery,
    setToDefault,
    triggerAction,
}) => {
    const resetSearchFields = () => {
        updateData({}, "/suche/juristischeperson")
        updateData({}, "/suche/natuerlicheperson")
    }
    const resetCustomerFields = () => {
        updateData({}, "/adressen/adresselist")
        updateData({}, "/adressen/adresse")
        updateData({}, "/suche/anbahnungList")
    }
    return {
        INIT_SUCHE: () => {
            loadCurrentLocationData().then(() => {
                getDataFromBackend(getDataFromPointer("/links/suche"))
                resetSearchFields()
            })
        },
        JP_SUCHE: () => {
            getDataFromBackendWithQuery(
                getDataFromPointer("/links/sucheJp"),
                "/suche/result/juristischeperson",
                getDataFromPointer("/suche/juristischeperson"),
            )
        },
        NP_SUCHE: () => {
            getDataFromBackendWithQuery(
                getDataFromPointer("/links/sucheNp"),
                "/suche/result/natuerlicheperson",
                getDataFromPointer("/suche/natuerlicheperson"),
            )
        },
        NAVIGATE_JP_KUNDE_ANLEGEN: () => {
            navigate(navigationPaths.JP_KUNDE_ANLEGEN)
            resetSearchFields()
        },
        NAVIGATE_NP_KUNDE_ANLEGEN: () => {
            navigate(navigationPaths.NP_KUNDE_ANLEGEN)
            resetSearchFields()
        },
        NP_KUNDE_ANLEGEN: () => {
            const kunde = getDataFromPointer(links.selectedNpKunde) ?? {}
            TomClient.callHallink(
                {href: uwpApiBase + "/kunde/np", methods: ["POST"]},
                {
                    vorname: kunde.vorname,
                    nachname: kunde.nachname,
                    titel: kunde.titel,
                    geburtsdatum: kunde.geburtsdatum,
                },
            )
            navigate(navigationPaths.SUCHE)
            updateData({}, "/suche/natuerlicheperson")
        },
        JP_KUNDE_ANLEGEN: () => {
            const kunde = getDataFromPointer(links.selectedJpKunde) ?? {}
            TomClient.callHallink(
                {href: uwpApiBase + "/kunde/jp", methods: ["POST"]},
                {
                    firmenname: kunde.firmenname,
                    webseite: kunde.webseite,
                    rechtsform: kunde.rechtsform,
                    namenszusatz: kunde.namenszusatz,
                },
            )
            navigate(navigationPaths.SUCHE)
            updateData({}, "/suche/juristischeperson")
        },
        SELECT_NP_KUNDE: ({payload}) => {
            resetCustomerFields()
            navigate(pathBuilder(payload._links._self))
        },
        SELECT_JP_KUNDE: ({payload}) => {
            resetCustomerFields()
            navigate(pathBuilder(payload._links._self))
        },
        JP_KUNDE_SPEICHERN: () => {
            sendDataToBackend(
                getDataFromPointer("/juristischeperson/_links/kunde:update"),
                getDataFromPointer("/juristischeperson"),
            )
        },
        ANBAHNUNG_ERSTELLEN_JP: () => {
            const selectedSparte = getDataFromPointer("/appdata/spartenauswahl")
            const linkMap = {
                SACH: "anbahnung:create:sach",
                CYBER: "anbahnung:create:cyber",
                UNFALL_GRUPPE: "anbahnung:create:unfallgruppe",
                UNFALL_EINZEL: "anbahnung:create:unfalleinzel",
            }
            getDataFromBackend(
                getDataFromPointer(
                    `/juristischeperson/_links/${linkMap[selectedSparte]}`,
                ),
                "/anbahnung",
            ).then((payload) => {
                navigate(pathBuilder(payload._links._self))
            })
        },
        ANBAHNUNG_ERSTELLEN_NP: () => {
            getDataFromBackend(
                getDataFromPointer(
                    "/natuerlicheperson/_links/anbahnung:create:sach",
                ),
                "/anbahnung",
            ).then((payload) => {
                navigate(pathBuilder(payload._links._self))
            })
        },
        LOAD_ANBAHNUNG: ({payload}) => {
            navigate(pathBuilder(payload._links._self))
        },
        CREATE_ADDRESS_JP: () => {
            sendDataToBackend(
                getDataFromPointer("/juristischeperson/_links/adresse:create"),
                {...rawAddress, ...getDataFromPointer("/adressen/adresse")},
            ).then(() => {
                getDataFromBackend(
                    getDataFromPointer("/juristischeperson/_links/adresseList"),
                    "/adressen/adresselist",
                )
                setToDefault("/adressen/adresse")
            })
        },
        CREATE_ADDRESS_NP: () => {
            sendDataToBackend(
                getDataFromPointer("/natuerlicheperson/_links/adresse:create"),
                {...rawAddress, ...getDataFromPointer("/adressen/adresse")},
            ).then(() => {
                getDataFromBackend(
                    getDataFromPointer("/natuerlicheperson/_links/adresseList"),
                    "/adressen/adresselist",
                )
                setToDefault("/adressen/adresse")
            })
        },
        EDIT_ADDRESS: ({payload}) => {
            updateData(
                {
                    ...defaultDataJson.adressen.adresse,
                    ...removeNullValues({...payload}),
                },
                "/adressen/adresse",
            )
        },
        UPDATE_ADDRESS: () => {
            sendDataToBackend(
                getDataFromPointer("/adressen/adresse/_links/adresseUpdate"),
                getDataFromPointer("/adressen/adresse"),
            ).then(() =>
                getDataFromBackend(
                    getDataFromPointer("/juristischeperson/_links/adresseList"),
                    "/adressen/adresselist",
                ),
            ).then(() => {
                updateData({}, "/adressen/adresse");
            }).catch((error) => {
                    console.error("Failed to update address:", error);
                });
        },
        INIT_KUNDE_JP: () => {
            loadCurrentLocationData("/juristischeperson").then(
                () => {
                    updateData(true, "/adressen/adresse/hauptadresse")
                    updateData(true, "/adressen/adresse/gueltig")
                    triggerAction("INIT_STAGING_AREA", {
                        stagingArea: getDataFromPointer(
                            "/juristischeperson/_links/createStagingArea",
                        ),
                    })
                    Promise.all([
                        getDataFromBackend(
                            getDataFromPointer(
                                "/juristischeperson/_links/anbahnungList",
                            ),
                            "/suche/anbahnungList",
                        ),
                        getDataFromBackend(
                            getDataFromPointer(
                                "/juristischeperson/_links/adresseList",
                            ),
                            "/adressen/adresselist",
                        ).then(
                            (payload) =>
                                payload._data.length > 0 &&
                                setToDefault("/adressen/adresse")
                        ),
                    ])
                },
                () => {},
            )
        },
        INIT_KUNDE_NP: () => {
            loadCurrentLocationData("/natuerlicheperson").then(
                () => {
                    updateData(true, "/adressen/adresse/hauptadresse")
                    updateData(true, "/adressen/adresse/gueltig")
                    triggerAction("INIT_STAGING_AREA", {
                        stagingArea: getDataFromPointer(
                            "/natuerlicheperson/_links/createStagingArea",
                        ),
                    })
                    Promise.all([
                        getDataFromBackend(
                            getDataFromPointer(
                                "/natuerlicheperson/_links/anbahnungList",
                            ),
                            "/suche/anbahnungList",
                        ),
                        getDataFromBackend(
                            getDataFromPointer(
                                "/natuerlicheperson/_links/adresseList",
                            ),
                            "/adressen/adresselist",
                        ).then(
                            (payload) =>
                                payload._data.length > 0 &&
                                setToDefault("/adressen/adresse")
                        ),
                    ])
                },
                () => {},
            )
        },
    }
}
